import { CompanyAdminLayout } from "../../components/CompanyAdmin/CompanyAdminLayout";
import React, { useState } from "react";
import Table from "../../components/UI/Table";
import { Button } from "../../components/UI/Button";
import TextInput from "../../components/UI/TextInput";
import { LucidePlus } from "lucide-react";
import Modal from "../../components/UI/Modal";

const NotificationManagement = () => {
  const [searchKeyword, setSearchKeyword] = useState("");

  interface Notification {
    id: number;
    title: string;
    content: string;
    sentWith: "이메일" | "SMS" | "카카오톡" | "네이버" | "웹알림";
    category:
      | "배송"
      | "생산"
      | "작업지시"
      | "공정"
      | "설비"
      | "보전"
      | "품질"
      | "검사"
      | "불량"
      | "자재"
      | "재고"
      | "입고"
      | "출고"
      | "출하"
      | "안전"
      | "환경"
      | "시스템"
      | "권한"
      | "긴급";
    recipientCount: number;
    createdAt: string;
  }

  const loadFromLocalStorage = () => {
    let notificationsData = localStorage.getItem("MOCK_notifications");
    if (notificationsData) {
      return JSON.parse(notificationsData) as Notification[];
    } else {
      saveToLocalStorage(
        JSON.parse(`[
  {
    "id": 1,
    "title": "정기총회 자료 1,200부 작업지시 생성",
    "content": "쇼핑몰 주문(ORD-20260220-0001) 접수로 A4 80g 백상지, 무선제본 기준 작업지시가 MES에 자동 등록되었습니다.",
    "sentWith": "웹알림",
    "category": "작업지시",
    "recipientCount": 4,
    "createdAt": "2026-02-20T09:02:00"
  },
  {
    "id": 2,
    "title": "A4 80g 백상지 재고 안전수량 이하",
    "content": "도서/제본 카테고리 주문 증가로 A4 80g 백상지 재고가 3박스로 감소했습니다. 자동 발주 검토가 필요합니다.",
    "sentWith": "SMS",
    "category": "재고",
    "recipientCount": 3,
    "createdAt": "2026-02-20T08:45:00"
  },
  {
    "id": 3,
    "title": "디지털 인쇄기 2호기 과열 감지",
    "content": "낱장출력(시험지 3,000매) 작업 중 장비 온도가 기준치 85℃를 초과했습니다. 점검이 필요합니다.",
    "sentWith": "카카오톡",
    "category": "설비",
    "recipientCount": 2,
    "createdAt": "2026-02-20T08:30:00"
  },
  {
    "id": 4,
    "title": "카탈로그 5,000부 인쇄 공정 완료",
    "content": "홍보물 카테고리 주문(ORD-20260219-0023)의 옵셋 인쇄 공정이 완료되었습니다. 코팅 공정으로 이동되었습니다.",
    "sentWith": "웹알림",
    "category": "생산",
    "recipientCount": 4,
    "createdAt": "2026-02-19T17:40:00"
  },
  {
    "id": 5,
    "title": "무광코팅 공정 처리시간 지연",
    "content": "포트폴리오 800부 코팅 작업이 평균 처리시간 대비 18% 지연되고 있습니다. 공정 상태를 확인하세요.",
    "sentWith": "이메일",
    "category": "공정",
    "recipientCount": 3,
    "createdAt": "2026-02-19T16:15:00"
  },
  {
    "id": 6,
    "title": "브로셔 작업 불량률 4.8% 경고",
    "content": "3단 접지 브로셔 작업에서 인쇄 밀림 현상 발생. 불량률이 허용 기준 3%를 초과했습니다.",
    "sentWith": "SMS",
    "category": "불량",
    "recipientCount": 3,
    "createdAt": "2026-02-19T14:20:00"
  },
  {
    "id": 7,
    "title": "하드커버 논문 제본 완료",
    "content": "하드커버논문 25권 작업이 완료되었습니다. 출하 대기 상태로 전환되었습니다.",
    "sentWith": "카카오톡",
    "category": "생산",
    "recipientCount": 2,
    "createdAt": "2026-02-19T13:05:00"
  },
  {
    "id": 8,
    "title": "대형출력 현수막 원단 입고 처리",
    "content": "실사출력용 현수막 원단 200m가 ERP에 입고 등록되었습니다. 재고 수량이 갱신되었습니다.",
    "sentWith": "웹알림",
    "category": "입고",
    "recipientCount": 2,
    "createdAt": "2026-02-19T11:30:00"
  },
  {
    "id": 9,
    "title": "재단기 칼날 교체 주기 도래",
    "content": "Polar 재단기 사용 횟수 5,000회 도달. 보전 작업 예약이 필요합니다.",
    "sentWith": "SMS",
    "category": "보전",
    "recipientCount": 2,
    "createdAt": "2026-02-19T10:55:00"
  },
  {
    "id": 10,
    "title": "제안서 300부 출하 완료",
    "content": "무선제본 제안서 300부가 출하 처리되었습니다. 송장번호가 자동 등록되었습니다.",
    "sentWith": "이메일",
    "category": "출하",
    "recipientCount": 3,
    "createdAt": "2026-02-18T18:10:00"
  },
  {
    "id": 11,
    "title": "품질 검사 합격 - 교육교재",
    "content": "교육교재 1,000부 색상 및 재단 품질 검사 통과. 합격 처리되었습니다.",
    "sentWith": "웹알림",
    "category": "검사",
    "recipientCount": 3,
    "createdAt": "2026-02-18T16:25:00"
  },
  {
    "id": 12,
    "title": "토너 사용량 급증 감지",
    "content": "최근 24시간 디지털 출력량 증가로 토너 사용량이 평균 대비 35% 상승했습니다.",
    "sentWith": "웹알림",
    "category": "자재",
    "recipientCount": 2,
    "createdAt": "2026-02-18T14:40:00"
  },
  {
    "id": 13,
    "title": "쇼핑몰 자동견적 계산 오류 발생",
    "content": "브로셔 상품 옵션 계산 중 예상 단가와 실제 단가 불일치가 감지되었습니다. 즉시 확인이 필요합니다.",
    "sentWith": "웹알림",
    "category": "시스템",
    "recipientCount": 1,
    "createdAt": "2026-02-18T13:10:00"
  },
  {
    "id": 14,
    "title": "COMPANY_MANAGER 권한 승인 요청",
    "content": "사용자 'manager02'가 매니저 권한 승인을 요청했습니다.",
    "sentWith": "이메일",
    "category": "권한",
    "recipientCount": 1,
    "createdAt": "2026-02-18T10:20:00"
  },
  {
    "id": 15,
    "title": "옵셋 인쇄기 1호기 긴급 정지",
    "content": "인쇄 중 급지 오류 발생으로 장비가 자동 정지되었습니다. 긴급 점검이 필요합니다.",
    "sentWith": "SMS",
    "category": "긴급",
    "recipientCount": 2,
    "createdAt": "2026-02-18T09:05:00"
  }
]`),
      );

      notificationsData = localStorage.getItem("MOCK_notifications");

      if (!notificationsData) throw new Error("MOCK_notifications is null");
      return JSON.parse(notificationsData) as Notification[];
    }
  };

  const saveToLocalStorage = (fontList: Notification[]) => {
    localStorage.setItem("MOCK_notifications", JSON.stringify(fontList));
    return fontList;
  };

  const [loadedData, setLoadedData] = useState<Notification[]>(
    loadFromLocalStorage(),
  );

  const [viewingNotification, setViewingNotification] =
    useState<Notification | null>(null);

  const [isDetailViewOpen, setIsDetailViewOpen] = useState(false);

  return (
    <>
      {isDetailViewOpen && (
        <Modal title="알림 정보" setIsModalVisible={setIsDetailViewOpen}>
          <h1 className="text-2xl font-bold text-start mt-3 mb-2 text-[#4285F4]">
            {viewingNotification?.title}
          </h1>

          <div className="w-[calc(100vw-20vw)] max-w-[31.875rem]" />

          <div className="flex flex-col items-start text-[#787A7D] text-[14px]">
            <span>
              <span className="font-bold">· 전송일:</span>{" "}
              {viewingNotification?.createdAt &&
                new Date(viewingNotification?.createdAt)
                  .toISOString()
                  .slice(0, 10)}
            </span>
          </div>
          <div className="flex flex-col items-start text-[#787A7D] text-[14px]">
            <span>
              <span className="font-bold">· 전송 수단:</span>{" "}
              {viewingNotification?.sentWith}
            </span>
          </div>
          <div className="flex flex-col items-start text-[#787A7D] text-[14px]">
            <span>
              <span className="font-bold">· 카테고리:</span>{" "}
              {viewingNotification?.category}
            </span>
          </div>
          <div className="flex flex-col items-start text-[#787A7D] text-[14px]">
            <span>
              <span className="font-bold">· 수신자 수:</span>{" "}
              {viewingNotification?.recipientCount}
            </span>
          </div>
          <div className="mb-4"></div>
          <hr className="mb-4" />
          <div className="break-keep flex text-start max-w-[31.875rem]">
            {viewingNotification?.content}
          </div>
        </Modal>
      )}
      <CompanyAdminLayout>
        <div className="p-5">
          <div
            className="mb-[1.25rem] / p-[1.25rem]
          / border border-[#d9d9d9] / rounded-[0.625rem] / bg-white
          / flex flex-col md:flex-row gap-[0.75rem] / justify-stretch"
          >
            <TextInput
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              className="w-full"
              placeholder="제목으로 검색"
            />
          </div>

          <div className="text-[12px]">
            <Table
              columnWidths={["200px", "130px", "130px", "130px", "150px"]}
              tabledata={{
                head: [<>제목</>, <>전송일</>, <>전송 수단</>, <>카테고리</>],
                body: loadedData
                  .filter((item) => {
                    if (searchKeyword === "") return true;

                    return item.title
                      .toLowerCase()
                      .includes(searchKeyword.toLowerCase());
                  })
                  .map((item) => [
                    <div
                      onClick={() => {
                        setIsDetailViewOpen(true);
                        setViewingNotification(item);
                      }}
                      role="button"
                      className="underline text-[#4285F4]"
                    >
                      {item.title}
                    </div>,
                    <>{new Date(item.createdAt).toISOString().slice(0, 10)}</>,
                    <>{item.sentWith}</>,
                    <>{item.category}</>,
                  ]),
              }}
            />
          </div>
        </div>
      </CompanyAdminLayout>
    </>
  );
};

export default NotificationManagement;
